import Header from "./Header";
import HeroSection from "./HeroSection";
import Features from "./Features";
import HowItWorks from "./HowItWorks";
import Packages from "./Packages";
import FAQ from "./FAQ";
import CTASection from "./CTASection";
import Footer from "./Footer";

export default function LandingPage() {
  return (
    <div className="min-h-screen w-full bg-bg-primary">
      <Header />
      <main>
        <HeroSection />
        <Features />
        <HowItWorks />
        <Packages />
        <FAQ />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
